export enum LabelType {
    PackingSlip = "Packing slip",
    PackingSlipBatch = 'PackingSlipBatch',
    AsMolded = 'As molded',
    CornerLabel = 'CornerLabel',
    StaticLabel = 'StaticLabel',
    FHCornerLabel = 'FHCornerLabel',
    PowderCoating = 'PowderCoating',
    MetalsProject = 'MetalsProject',
    MetalsProduct = 'MetalsProduct',
    PlasticsInventoryBin = 'PlasticsInventoryBin',
    PlasticsInventoryBinMulti = 'PlasticsInventoryBinMulti',
    PlasticsKit = 'PlasticsKit',
    ObsessedEngineeringProduct = 'ObsessedEngineeringProduct',
    ObsessedEngineeringSkid = 'ObsessedEngineeringSkid',
    Shipment = 'Shipment',
    C3HardwareItemOrientation = 'C3HardwareItemOrientation',
    C3HardwareItemBin = 'C3HardwareItemBin',
    InjectionMoldingProduct = 'InjectionMoldingProduct',
    InjectionMoldingTraceability = 'InjectionMoldingTraceability',
    MetalsPackUnit = 'MetalsPackUnit',
    MetalsInventoryBin = 'MetalsInventoryBin',
    MetalsInventoryBundle = 'MetalsInventoryBundle',
}
